import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

new Swiper('[data-news-preview-slider]', {
  loop: false,
  spaceBetween: 32,
  navigation: {
    nextEl: '.newsPreviewSlider._next',
    prevEl: '.newsPreviewSlider._prev',
  },
  breakpoints: {
    320: {
      slidesPerView: 'auto',
      spaceBetween: 12,
    },
    768: {
      slidesPerView: 'auto',
      spaceBetween: 32,
    },
    1280: {
      slidesPerView: 3,
    },
    1600: {
      slidesPerView: 3,
    },
    1920: {
      slidesPerView: 3,
    },
  },
});

new Swiper('[data-news-slider]', {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 0,
  pagination: {
    el: '[data-news-slider-pagination]',
    type: 'custom',
    renderCustom: function(swiper, current, total) {
      let currentSlide = current.toString();
      let totalSlide = total.toString();
      return `<span>${ currentSlide }&nbsp;-&nbsp;${ totalSlide }</span>`;
    },
  },
  navigation: {
    nextEl: '.newsSlider._next',
    prevEl: '.newsSlider._prev',
  },
  breakpoints: {
    320: {
      spaceBetween: 8,
    },
    768: {
      spaceBetween: 8,
    },
    1024: {
      spaceBetween: 8,
    },
    1280: {
      spaceBetween: 0,
    },
  },
});
